import { Order } from '../../proto/generated/order'
import { isIcebergGroup, OrderOrIcebergGroup } from '../../util/icebergOrders'
import { OrdersNavButtonsDetailed } from '../postionsWidget'

export type OrderRowRenderProps = {
    order: OrderOrIcebergGroup
    tabType: OrdersNavButtonsDetailed
    hideOrderStatus?: boolean
    isNestedInBasket?: boolean
}

const orderExecutionParamsEqual = (
    a: Order['orderExecutionParams'],
    b: Order['orderExecutionParams']
): boolean => JSON.stringify(a ?? null) === JSON.stringify(b ?? null)

const orderFieldsEqual = (a: Order, b: Order): boolean =>
    a.clientOrderId === b.clientOrderId &&
    a.orderId === b.orderId &&
    a.status === b.status &&
    a.quantity === b.quantity &&
    a.filledQuantity === b.filledQuantity &&
    a.price === b.price &&
    a.averageTradedPrice === b.averageTradedPrice &&
    a.triggerPrice === b.triggerPrice &&
    a.exchangeTimestamp === b.exchangeTimestamp &&
    a.created === b.created &&
    orderExecutionParamsEqual(a.orderExecutionParams, b.orderExecutionParams)

export const orderOrGroupRowEqual = (a: OrderOrIcebergGroup, b: OrderOrIcebergGroup): boolean => {
    const aIce = isIcebergGroup(a)
    const bIce = isIcebergGroup(b)
    if (aIce !== bIce) return false
    if (aIce && bIce) {
        return (
            a.batchId === b.batchId &&
            a.basketId === b.basketId &&
            a.totalQuantity === b.totalQuantity &&
            a.totalFilledQuantity === b.totalFilledQuantity &&
            a.executedLegs === b.executedLegs &&
            a.totalLegs === b.totalLegs &&
            a.allOrders.length === b.allOrders.length &&
            orderFieldsEqual(a.allOrders[0], b.allOrders[0])
        )
    }
    return orderFieldsEqual(a as Order, b as Order)
}

export const areOrderRowRenderPropsEqual = (
    prev: OrderRowRenderProps,
    next: OrderRowRenderProps
): boolean =>
    prev.tabType === next.tabType &&
    prev.hideOrderStatus === next.hideOrderStatus &&
    prev.isNestedInBasket === next.isNestedInBasket &&
    orderOrGroupRowEqual(prev.order, next.order)
